import { useState } from "react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { errMsg } from "../../lib/api";
import { adminApi } from "../../lib/adminApi";
import { OptionPills } from "../OptionPills";
import { SCORING, Section } from "../CreateTournamentDialog";
import { LimitsFields, limitsError, normalizeLimits } from "../LimitsFields";
import { RoundRangeFields } from "../RoundRangeFields";
import { CompetitionSelect } from "../CompetitionSelect";

const INIT = { name: "", competition: "SA", scoring: { fisse: 2, doppie: 1, esatto: 3, bonus: 10 }, limits: { fisse: 5, doppie: 5, esatti: 1 }, start_round: null, end_round: null };

export const AdminTournamentForm = ({ initial, onSaved }) => {
  const editing = !!initial;
  const [f, setF] = useState(() => (initial ? { ...INIT, ...initial, limits: normalizeLimits({ ...initial.limits }, initial.competition) } : INIT));
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const err = limitsError(f.limits, f.competition);
    if (err) return toast.error(err);
    setBusy(true);
    try {
      const body = { name: f.name, competition: f.competition, scoring: f.scoring, limits: f.limits, start_round: f.start_round, end_round: f.end_round };
      const r = editing ? await adminApi.put(`/tournaments/${initial.id}`, body) : await adminApi.post("/tournaments", body);
      toast.success(editing ? "Torneo aggiornato" : "Torneo pubblico creato");
      onSaved?.(r.data);
    } catch (e2) {
      toast.error(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-5" data-testid={editing ? "admin-edit-form" : "admin-create-form"}>
      <Section title="Nome torneo">
        <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} required data-testid="admin-name-input" className="h-11 bg-[#0A0D14] border-[#26334D]" />
      </Section>
      {!editing && (
        <Section title="Competizione">
          <CompetitionSelect value={f.competition} onChange={(v) => setF({ ...f, competition: v, limits: normalizeLimits({ ...f.limits, unlimited: false }, v) })} testId="admin-competition-select" />
        </Section>
      )}
      <Section title="Durata del torneo">
        <RoundRangeFields competition={f.competition} start={f.start_round} end={f.end_round} testPrefix="admin" keepValues={editing}
          fetchRounds={(c) => adminApi.get(`/competitions/${c}/rounds`).then((r) => r.data)} onChange={(r) => setF((p) => ({ ...p, ...r }))} />
      </Section>
      {SCORING.map(([k, label, , opts]) => (
        <Section key={k} title={label}>
          <OptionPills options={opts} value={f.scoring[k]} onChange={(v) => setF({ ...f, scoring: { ...f.scoring, [k]: v } })} testId={`admin-scoring-${k}`} />
        </Section>
      ))}
      <Section title="Limiti per giornata">
        <LimitsFields value={f.limits} competition={f.competition} onChange={(limits) => setF({ ...f, limits })} testPrefix="admin" />
      </Section>
      <Button type="submit" disabled={busy} data-testid="admin-save-tournament-button" className="w-full h-11 rounded-full bg-emerald-500 hover:bg-emerald-400 text-[#0A0D14] font-bold uppercase tracking-wider">
        {busy ? "Salvataggio…" : editing ? "Salva modifiche" : "Crea torneo pubblico"}
      </Button>
    </form>
  );
};
